<template lang="html">

  <section class="login">
    <div class="pageHeading">
    <h1 style="text-align: center;">Login To Trip</h1>
    </div>
    <v-container grid-list-md text-xs-center>
      <v-layout row wrap>
        <v-flex xs12 md4  v-for="trip in tripList">

    <v-card class="mb-1">
      <v-container>
        <v-card elevation="1">

          <v-card-title primary-title>
            <v-flex >
              <h3 class="mb-0">{{trip.prettyName}}</h3>

            </v-flex>


          </v-card-title>

          <v-container style="border-top: lightgray 1px solid;
    cursor: pointer;"  >

            <v-layout row wrap >
              <v-flex  text-xs-center>
                <span class="topTextBottomLabels">{{trip.departDate}}</span>
                <br/>
                <strong class="bottomLabels">Departure Date</strong>
              </v-flex>

              <v-flex text-xs-center>
                <v-btn class="mx-2"   @click="openTrip(trip._id, trip)"  dark small color="primary">Login</v-btn>
              </v-flex>


            </v-layout>
          </v-container>

        </v-card>
      </v-container>

    </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'select-trip',
    props: [],
    mounted() {
    },
    data() {
      return {
      }
    },
    methods: {
      openTrip(tripServerID, trip) {
        console.log('opening trip', trip)
        this.$filterTripID = trip
        this.$forceSelectTrip = false
        this.$router.push('/')
      }
    },
    computed: {
      tripList() {
        if(this.$forceSetupAgain) {

          console.log('FORCE SETUP AGAIN')
          this.$forceSelectTrip = false
          this.$forceSetupAgain = false
          this.$router.push('/Setup')
        }

        if (this.$structuredData.trips == undefined) {
          return [];
        } else if(this.$structuredData.trips.length < 2 ) {
          this.$router.push('/')
        } else {
          return this.$structuredData.trips
        }

      }
    }
}
</script>

<style scoped lang="scss">
.login {
}
</style>
